import { USER_PERMISSION_FLAG, VIRTUAL_ENTITY_FLAG } from "../constants";
import { get, isBoolean, isPlainObject } from "lodash";
import { isSelectedMerchantVE } from "./merchantSelectorHelper";
function getFeatureFlagFromLS() {
    try {
        var item = localStorage.getItem("featureFlags");
        return item ? JSON.parse(item) : {};
    }
    catch (err) {
        return {};
    }
}
export function haveAccessToFeature(feature) {
    var featureFlags = getFeatureFlagFromLS();
    var hasAccess = get(featureFlags, feature, false);
    return isBoolean(hasAccess) ? hasAccess : false;
}
export function getUserPermissionFlagFromLS() {
    var flags = getFeatureFlagFromLS();
    var userPermissionFlag = get(flags, USER_PERMISSION_FLAG, { enabled: false, config: {}, module: {} });
    return isPlainObject(userPermissionFlag) ? userPermissionFlag : { enabled: false, config: {}, module: {} };
}
/**
 * Returns if the flag is enabled, true if enabled, false if not
 */
export function isPermissionSystemFlagEnabled() {
    return getUserPermissionFlagFromLS().enabled;
}
/**
 * Return specific module name value for given key
 * @param {HasPermissionToViewParams} params - The parameters getModuleNameByKey function
 * @returns {string} - The value of the module name
 */
export function getModuleNameByKey(key) {
    return get(getUserPermissionFlagFromLS().module, key, '');
}
/**
 * Return specific config value for given key
 * @param {HasPermissionToViewParams} params - The parameters getConfigByKey function
 * @returns {string} - The value of the confid
 */
export function getConfigByKey(key) {
    return get(getUserPermissionFlagFromLS().config, key, '');
}
/**
 * Returns all the module names from feature falg
 */
export function getAllModules() {
    return getUserPermissionFlagFromLS().module || {};
}
/**
 * Returns the full config object from feature falg
 */
export function getFullConfig() {
    return getUserPermissionFlagFromLS().config || {};
}
/*
==================================================================
Virtual Entity - required as UP system is not fully migrated yet
==================================================================
*/
export function getVirtualEnitityFlagFromLS() {
    var flags = getFeatureFlagFromLS();
    var virtualEntityFlag = get(flags, VIRTUAL_ENTITY_FLAG, { enabled: false, config: {}, module: {} });
    return isPlainObject(virtualEntityFlag) ? virtualEntityFlag : { enabled: false, enabledTabs: {}, initialTabPath: "" };
}
export function isVirtualEntitySystemEnabled() {
    return getVirtualEnitityFlagFromLS().enabled;
}
export function isTabEnabledForVE(key) {
    if (!isSelectedMerchantVE()) {
        return true;
    }
    return get(getVirtualEnitityFlagFromLS().enabledTabs, key, false) === true;
}
export function getVEFirstTabToShow() {
    return getVirtualEnitityFlagFromLS().initialTabPath;
}
//# sourceMappingURL=featureFlagHelper.js.map